import {
    GET_DETAILED_PRODUCT_TEMPLATE_LIST,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS,
    GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE,
    GET_TEMPLATE_DETAILS,
    GET_TEMPLATE_DETAILS_SUCCESS,
    GET_TEMPLATE_DETAILS_FAILURE,
    UPDATE_PRODUCT_TEMPLATE,
    UPDATE_PRODUCT_TEMPLATE_SUCCESS,
    UPDATE_PRODUCT_TEMPLATE_FAILURE,
    CREATE_PRODUCT_TEMPLATE,
    CREATE_PRODUCT_TEMPLATE_SUCCESS,
    CREATE_PRODUCT_TEMPLATE_FAILURE,
    RESET_CREATE_TEMPLATE,
    GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE,
    GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS,
    GET_DATA_FOR_PRODUCT_TEMPLATE,
} from '../actions';

const initialState = {
    detailedProductTemplateList: {
        templates: [],
        Loading: false,
        StatusCode: 0,
        StatusMessage: '',
        pagination: {
            pageNum: 0,
            pageLimit: 50,
        },
        totalNoOfResults: 0,
    },
    templateDetails: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    createTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    updateTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
    orderTemplate: {
        loading: false,
        statusCode: 0,
        statusMessage: '',
    },
};

const productTemplatesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DETAILED_PRODUCT_TEMPLATE_LIST:
            return {
                ...state,
                detailedProductTemplateList: {
                    ...state.detailedProductTemplateList,
                    templates: [],
                    loading: true,
                    StatusCode: 0,
                    StatusMessage: '',
                },
            };
        case GET_DETAILED_PRODUCT_TEMPLATE_LIST_SUCCESS:
            return {
                ...state,
                detailedProductTemplateList: {
                    ...state.detailedProductTemplateList,
                    templates: action.payload,
                    loading: false,
                    StatusCode: action.statusCode,
                    StatusMessage: action.statusMessage,
                    pagination: {
                        ...state.detailedProductTemplateList.pagination,
                        ...action.pagination,
                    },
                    totalNoOfResults: action.totalNoOfResults,
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                templateDetails: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_DETAILED_PRODUCT_TEMPLATE_LIST_FAILURE:
            return {
                ...state,
                detailedProductTemplateList: {
                    ...state.detailedProductTemplateList,
                    templates: [],
                    loading: false,
                    StatusCode: action.statusCode,
                    StatusMessage: action.statusMessage,
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_TEMPLATE_DETAILS:
            return {
                ...state,
                templateDetails: {
                    loading: true,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_TEMPLATE_DETAILS_SUCCESS:
            return {
                ...state,
                templateDetails: {
                    ...state.templateDetails,
                    ...action.payload,
                    loading: false,
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_TEMPLATE_DETAILS_FAILURE:
            return {
                ...state,
                templateDetails: {
                    loading: false,
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case UPDATE_PRODUCT_TEMPLATE:
            return {
                ...state,
                updateTemplate: {
                    loading: true,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case UPDATE_PRODUCT_TEMPLATE_SUCCESS:
            return {
                ...state,
                updateTemplate: {
                    loading: false,
                    statusCode: action.payload?.statusCode,
                    statusMessage: action.payload?.statusMessage,
                },
            };
        case UPDATE_PRODUCT_TEMPLATE_FAILURE:
            return {
                ...state,
                updateTemplate: {
                    loading: false,
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        case CREATE_PRODUCT_TEMPLATE:
            return {
                ...state,
                createTemplate: {
                    loading: true,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case CREATE_PRODUCT_TEMPLATE_SUCCESS:
            return {
                ...state,
                createTemplate: {
                    loading: false,
                    statusCode: action.payload?.statusCode,
                    statusMessage: action.payload?.statusMessage,
                },
            };
        case CREATE_PRODUCT_TEMPLATE_FAILURE:
            return {
                ...state,
                createTemplate: {
                    loading: false,
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        case RESET_CREATE_TEMPLATE:
            return {
                ...state,
                createTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                updateTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                orderTemplate: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
                templateDetails: {
                    loading: false,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_DATA_FOR_PRODUCT_TEMPLATE:
            return {
                ...state,
                orderTemplate: {
                    loading: true,
                    statusCode: 0,
                    statusMessage: '',
                },
            };
        case GET_DATA_FOR_PRODUCT_TEMPLATE_SUCCESS:
            return {
                ...state,
                orderTemplate: {
                    loading: false,
                    ...action?.payload,
                },
            };

        case GET_DATA_FOR_PRODUCT_TEMPLATE_FAILURE:
            return {
                ...state,
                orderTemplate: {
                    loading: false,
                    statusCode: action.statusCode,
                    statusMessage: action.statusMessage,
                },
            };
        default: {
            return { ...state };
        }
    }
};

export default productTemplatesReducer;
